import React from 'react';
import cn from 'classnames';
import Footer from 'components/Footer';
import Header from 'components/Header';
import Headroom from 'react-headroom';

import styles from './Pricing.module.scss';

export default function Pricing(props) {
  return (
    <React.Fragment>
      <Headroom tag="header" className="page-header">
        <nav className="max:show">
          <Header />
        </nav>
      </Headroom>

      <div className={cn(styles.root, 'pricing')}>
        <div className={styles.root__cell}>
          <img src={require('assets/0ebb617e3a45adc94005bd189e39938a.png')} alt="alt text" className={styles.image} />
        </div>

        <div className={styles.flex_col}>
          <h1 className={styles.hero_title}>PRICING</h1>
          <h3 className={styles.subtitle}>
            Experience the unlimited potential of our Premium Tier or begin your ascent <br />
            with the Freemium Tier to propel your profile to new heights.
          </h3>

          <div className={styles.flex_row}>
            <div className={styles.flex_row__cell}>
              <div className={styles.content_box1}>
                <div className={styles.flex_col1}>
                  <h3 className={styles.subtitle1}>Free</h3>
                  <h5 className={styles.highlights}>
                    Basic profile creation
                    <br />
                    Limited profile views
                    <br />
                    AI chatbot interaction
                    <br />
                    Privacy protection
                    <br />
                    Get started for free
                  </h5>

                  <div className={styles.box3}>
                    <h5 className={styles.highlights1}>Start Today</h5>
                  </div>

                  <div className={styles.flex_col1__cell}>
                    <img
                      src={require('assets/7dd19196ecb76e348496c27c23cebe3e.png')}
                      alt="alt text"
                      className={styles.image1}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.flex_row__spacer} />
            <div className={styles.flex_row__cell}>
              <div className={styles.content_box}>
                <div className={styles.flex_col2}>
                  <h3 className={styles.subtitle1}>Pro</h3>
                  <h5 className={styles.highlights2}>
                    All the free plan
                    <br />
                    Unlimited Profile Views
                    <br />
                    Advanced Search and Filtering
                    <br />
                    Insights into Candidate Interactions
                    <br />
                    Priority Support
                  </h5>

                  <div className={styles.box31}>
                    <h5 className={styles.highlights1}>Start Today</h5>
                  </div>

                  <div className={styles.flex_col2__cell}>
                    <img
                      src={require('assets/45894d709a0d6f4b062e54f9f8500e4c.png')}
                      alt="alt text"
                      className={styles.image2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.box5}>
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
}
